import {AutoInitializing, UnLitElement} from "../../../common/elements";
import {customElement, queryAll} from "lit/decorators.js";
import {ManagingResources} from "../../../common/lifetime";
import {SearchFacade} from "./searchFacade";
import {resolve} from "../../../container";
import {ScrollableBar} from "../../../page/elements/scrollableBar";
import {Dictionary} from "../../../page/elements/dictionary";
import {html, type PropertyValues, type TemplateResult} from "lit";
import {ResizeObserverFactory} from "../../../common/observation";
import {templateContent} from "lit/directives/template-content.js";
import {SearchGroupTab} from "./searchGroupTab";
import type {DirectiveResult} from "lit/directive";

@customElement("eop-search-group-tabs")
export class EopSearchGroupTabs extends ManagingResources(AutoInitializing(UnLitElement)) {

    @queryAll(".content-search-tab-item")
    private searchTabNodes: NodeListOf<HTMLElement>;
    @queryAll("eop-search-group-tab")
    private searchTabComponents: NodeListOf<SearchGroupTab>;
    private focusResizeObserver: ResizeObserver;
    private scrollBar: ScrollableBar;
    protected dictionary: Dictionary;

    private searchTabs: DirectiveResult[];

    public constructor(
        private searchFacade: SearchFacade = resolve(SearchFacade),
        resizeObserverFactory: ResizeObserverFactory = resolve(ResizeObserverFactory)
    ) {
        super();
        this.focusResizeObserver = resizeObserverFactory.create(() => this.searchFacade.focus());
    }

    public connectedCallback(): void {
        super.connectedCallback();
        this.dictionary = Dictionary.of(this);
        this.focusResizeObserver.observe(this);
        this.searchTabs = Array.from(this.querySelectorAll<HTMLTemplateElement>(".content-search-tab-item-template"))
            .map(template => templateContent(template));
    }

    public disconnectedCallback(): void {
        this.focusResizeObserver.disconnect();
        this.scrollBar.disconnect();
        super.disconnectedCallback();
    }

    protected firstUpdated(_changedProperties: PropertyValues): void {
        super.firstUpdated(_changedProperties);
        this.searchTabNodes.forEach(item => item.classList.add("scrollable-item"));
        this.scrollBar = new ScrollableBar(this.renderRoot.querySelector(".content-search-tabs")!, this.dictionary);
        const activeGroup = this.searchFacade.activeGroup();
        if (!activeGroup || activeGroup.name === "default") {
            this.searchTabComponents.item(0)?.activate();
        }
    }

    public render(): TemplateResult {
        return html`
            <div class="content-search-tabs-container">
                <nav class="content-search-tabs">
                    <div class="content-search-tab-items horizontally-scrollable-area">
                        ${this.searchTabs}
                    </div>
                </nav>
            </div>
        `;
    }
}
